import moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from "@/assets/common/Modal/Modal.vue";

@Component({
    components: { Modal }
})
export default class SelectFromWorkRecords extends Vue {
    @Prop()
    private value?: boolean;

    @Emit('input')
    input(value: boolean): void {
        value
    }

    @Prop()
    private preSelectItem?: string;

    @Prop()
    private option?: string;

    @Prop()
    private refId?: string;

    @Prop()
    private workDate?: Date;

    @Prop()
    private mode?: string;

    @Prop()
    private work?: string;

    @Prop()
    private plantingAndAgriField?: any;

    private selectedWorkRecordId = '';
    private workRecords: [] = [];

    @Emit('selectedItem')
    selectedItem(): any {
        this.input(false)
        return this.workRecords.find((record: any) => record.id === this.selectedWorkRecordId);
    }

    @Watch('value')
    async whenOpen(): Promise<void> {
        if (this.value) {
            this.selectedWorkRecordId = this.preSelectItem ? this.preSelectItem : '';
            this.$apiClient.doRequest('get', `/work_records/calendar/${this.workDate}`).then((ret) => {
                this.workRecords = ret.filter((wr: any) => 
                    wr.agri_field.id === this.plantingAndAgriField?.agriField?.id &&
                    wr.planting.id === this.plantingAndAgriField?.planting?.id &&
                    wr.workItem.name === this.work &&
                    (
                        (this.work === "収穫" && (
                            wr.harvestRecordId.length === 0 || 
                            (this.mode === "edit" && this.option === "LINKWORK" && wr.harvestRecordId.length === 1 && wr.harvestRecordId[0] === this.refId)
                        )) ||
                        (this.work === "出荷" && (
                            wr.shippingRecordId.length === 0 || 
                            (this.mode === "edit" && this.option === "LINKWORK" && wr.shippingRecordId.length === 1 && wr.shippingRecordId[0] === this.refId)
                        ))
                    )
                );
            }).catch((error) => {
                console.log(error);
            });
        } else {
            this.selectedWorkRecordId = ''
        }
    }

    private formatWorkDate(date: Date) {
        return moment(date).format('YYYY年M月D日')
    }

    private selectWorkRecord(id: string) {
        this.selectedWorkRecordId = id
    }

    private cancel() {
        this.input(false)
    }

    private getTotalTime(time: number): string {
        if(time % 60 === 0) {
            return Math.floor(time / 60) + "時間";
        } else if(time > 60) {
            return Math.floor(time / 60) + "時間" + Math.floor(time % 60) + "分";
        } else {
            return time + "分";
        }
    }

    get isModalVisible(): boolean {
        return this.value ? this.value : false
    }

    set isModalVisible(value: boolean) {
        this.input(value)
    }
}